import { Spin } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ProjectListHeader from "../../layout/data360Live/projectListHeader";
import TabList from "../../layout/data360Live/tab";
import {
  // GET_CURRENT_PROJECT,
  GET_PROJECT_REQUEST,
} from "../../redux/data360Live_Project/types";

const HomePage = () => {
  const dispatch = useDispatch();
  const { loading, projectDetails, currentProject } = useSelector(
    (state) => state.data360LiveProjectReducer
  );
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    dispatch({
      type: GET_PROJECT_REQUEST,
    });
  }, []);

  useEffect(() => {
    if (projectDetails?.projects?.length > 0) {
      setProjectList(projectDetails.projects);
    }
  }, [projectDetails]);

  if (loading) {
    return (
      <div className="home-loader">
        <Spin size="large" tip="Loading data..." />
      </div>
    );
  }

  const handlerClearSearch = () => {
    setProjectList(projectDetails.projects);

    // dispatch({
    //   type: GET_CURRENT_PROJECT,
    //   payload: {},
    // });
  };

  const reloadNewData = () => {
    dispatch({
      type: GET_PROJECT_REQUEST,
    });
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="flex-auto parent-of-all">
        <ProjectListHeader
          projectListData={projectList}
          reloadData={reloadNewData}
          setProjectList={setProjectList}
          handlerClearSearch={handlerClearSearch}
        />
        {currentProject?.project_id && <TabList />}
      </div>
    </div>
  );
};

export default HomePage;
